import { formatChiefComplaints } from './chiefComplaintsText'

export type FingerprintableEvent = {
  id: number
  room_id?: string
  schedule_instance?: string
  start_time: string | Date
  end_time: string | Date
  emr_updated_at?: string | null
  sms_notification?: string | number
  temperature?: number | null
  consultation_staff?: number
  consultation_staff_name?: string
  current_location?: string | null
  status?: { code?: number }
  category?: { code?: number }
  title?: string
  jitsi_telehealth?: { doctor_embed_url?: string; patient_short_link?: string } | null
  chief_complaints?: { complaint?: string }[]
  joint_providers?: { id: number; name: string }[]
  series?: { id: number; step: number; total: number; type: string } | null
}

const toFingerprintTime = (value: string | Date): string | number =>
  value instanceof Date ? value.getTime() : value

/**
 * Display-relevant fields only. `updated_at` is omitted so a PUT/Pusher echo of the
 * same appointment does not clone the dataSource and rebuild the scheduler.
 * `schedule_instance` (or the explicit instance key) keeps stacked calendars isolated.
 */
export const fingerprintScheduleEvent = (
  event: FingerprintableEvent,
  instanceKey?: string,
): string =>
  [
    instanceKey || event.schedule_instance || '',
    event.id,
    event.room_id,
    toFingerprintTime(event.start_time),
    toFingerprintTime(event.end_time),
    event.emr_updated_at ?? '',
    event.status?.code ?? '',
    event.category?.code ?? '',
    event.title ?? '',
    event.sms_notification ?? '',
    event.temperature ?? '',
    event.consultation_staff ?? '',
    event.consultation_staff_name ?? '',
    event.current_location ?? '',
    event.jitsi_telehealth?.doctor_embed_url ?? '',
    event.jitsi_telehealth?.patient_short_link ?? '',
    formatChiefComplaints(event.chief_complaints),
    (event.joint_providers ?? []).map((provider) => `${provider.id}:${provider.name}`).join(','),
    event.series
      ? `${event.series.id}:${event.series.step}/${event.series.total}:${event.series.type}`
      : '',
  ].join('|')
